/* app/src/components/Content/index.js */
import { ContentCard } from '@mch-group/uikit-components'

const ContentCardComponent = (data) => <ContentCard {...data} />

export default ContentCardComponent